(() => {
  const TIMER_INTERVAL_MS = 1000;
  const FALLBACK_PACK_COUNT = 9;
  const EXTENDED_LAUNCH_AT_OVERRIDES = {
    "2026-05-29T14:00:00-07:00": "2026-05-29T14:15:00-07:00",
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-wl-pack-timer]").forEach(initTimerPage);
  };

  const initTimerPage = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.wlPackTimerInitialized === "true") return;
    root.dataset.wlPackTimerInitialized = "true";

    renderPackRail(root);

    const timer = root.querySelector("[data-launch-timer]");
    const launchAtMs = parseLaunchAt(normalizeLaunchAt(root.dataset.launchAt || ""));
    let timerId = 0;

    const finish = () => {
      if (timerId) window.clearInterval(timerId);
      if (timer) timer.textContent = "00:00:00";
      root.classList.add("is-launched");
      root.dispatchEvent(new CustomEvent("wl:pack-launch-ready", { bubbles: true }));
      if (root.dataset.autoRedirect === "true" && root.dataset.launchUrl) {
        window.location.assign(root.dataset.launchUrl);
      }
    };

    const render = () => {
      if (!timer || launchAtMs === null) {
        finish();
        return;
      }

      const remainingMs = launchAtMs - Date.now();
      if (remainingMs <= 0) {
        finish();
        return;
      }

      timer.textContent = formatLaunchCountdown(remainingMs);
    };

    render();
    if (launchAtMs !== null && launchAtMs > Date.now()) {
      timerId = window.setInterval(render, TIMER_INTERVAL_MS);
    }
  };

  const renderPackRail = (root) => {
    const rail = root.querySelector("[data-launch-packs]");
    if (!(rail instanceof HTMLElement)) return;

    const images = launchPackImages(root);
    rail.replaceChildren();
    rail.classList.toggle("is-single", images.length === 1);
    if (images.length > 0) {
      const midpoint = (images.length - 1) / 2;
      images.forEach((imageUrl, index) => {
        const distance = index - midpoint;
        const image = document.createElement("img");
        image.src = imageUrl;
        image.alt = "";
        image.loading = "eager";
        image.decoding = "async";
        image.draggable = false;
        image.style.setProperty("--launch-pack-y", `${Math.abs(distance) * 5}px`);
        image.style.setProperty("--launch-pack-rotate", `${distance * 0.8}deg`);
        image.style.setProperty("--launch-pack-z", String(index + 1));
        rail.append(image);
      });
      return;
    }

    Array.from({ length: FALLBACK_PACK_COUNT }, (_, index) => {
      const midpoint = (FALLBACK_PACK_COUNT - 1) / 2;
      const distance = index - midpoint;
      const pack = document.createElement("span");
      pack.className = "wl-pack-timer-page__fallback-pack";
      pack.setAttribute("aria-hidden", "true");
      pack.style.setProperty("--launch-pack-y", `${Math.abs(distance) * 5}px`);
      pack.style.setProperty("--launch-pack-rotate", `${distance * 0.8}deg`);
      pack.innerHTML = "<b>WL</b>";
      rail.append(pack);
    });
  };

  const launchPackImages = (root) => {
    const source = root.querySelector("[data-launch-pack-images]")?.textContent?.trim();
    if (!source) return [];
    try {
      const parsed = JSON.parse(source);
      if (!Array.isArray(parsed)) return [];
      return parsed.map((value) => String(value || "").trim()).filter(Boolean);
    } catch (error) {
      console.warn("Could not parse WL launch pack images.", error);
      return [];
    }
  };

  const parseLaunchAt = (launchAt) => {
    const timestamp = Date.parse(launchAt);
    return Number.isFinite(timestamp) ? timestamp : null;
  };

  const normalizeLaunchAt = (launchAt) => EXTENDED_LAUNCH_AT_OVERRIDES[launchAt] || launchAt;

  const formatLaunchCountdown = (remainingMs) => {
    const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const time = [hours, minutes, seconds].map((part) => String(part).padStart(2, "0")).join(":");
    return `${days}D ${time}`;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
